<div class="">
  <div class="flex flex-col gap-3">
    <ng-container>
      <div class="flex items-center">
        <p-radioButton
          [inputId]="'Everywhere'"
          [value]="0"
          [(ngModel)]="filterType"
          (onClick)="resetAllData()" />
        <label class="ml-2" [for]="'Everywhere'">{{ 'Everywhere' | translate }}</label>
      </div>

      <div class="flex items-center">
        <p-radioButton [inputId]="'selectedCountries'" [value]="1" [(ngModel)]="filterType" />
        <label class="ml-2" [for]="'selectedCountries'">{{
          'Selected countries' | translate
        }}</label>
        <mat-icon
          class="ml-1 text-blue-500 cursor-pointer text-lg"
          fontIcon="diamond"
          tooltipPosition="right"
          [appendTo]="'body'"
          pTooltip="{{ 'Only for premium subscribers' | translate }}"
          (click)="miscService.openPremium()" />
      </div>

      @if (filterType === 1) {
        <offconon-all-country-multi-select-list [locationFormControl]="countryFormControl" />
      }

      <div class="flex items-center">
        <p-radioButton
          [inputId]="'selectedCities'"
          [value]="2"
          [(ngModel)]="filterType"
          (onClick)="resetCountry()" />
        <label class="ml-2" [for]="'selectedCities'">{{ 'Search city' | translate }}</label>
        <mat-icon
          class="ml-1 text-blue-500 cursor-pointer text-lg"
          fontIcon="diamond"
          tooltipPosition="right"
          [appendTo]="'body'"
          pTooltip="{{ 'Only for premium subscribers' | translate }}"
          (click)="miscService.openPremium()" />
      </div>
    </ng-container>
    @if (filterType === 2) {
      <input type="text" pInputText class="w-full" [formControl]="cityFormControl" />

      @if (showInfo) {
        <small class="block">
          {{
            'This feature only shows members whose privacy settings allows us to show their city.'
              | translate
          }}
          {{
            'You can only use this feature if your privacy settings allow your city to be displayed.'
              | translate
          }}
        </small>
      }

      <div class="pb-1 m-3">
        <div class="pb-3">
          <div class="text-teal-500 w-full font-bold mt-2 mb-4">
            {{ 'Distance' | translate }}
          </div>

          <div class="flex items-center pb-2">
            <p-radioButton
              [value]="false"
              [inputId]="'allDistance'"
              [(ngModel)]="distanceSwitch"
              (onClick)="resetDistance()" />
            <label for="allDistance" class="ml-2">{{ 'All' | translate }}</label>
          </div>

          <div class="flex items-center pb-2">
            <p-radioButton
              [value]="true"
              [inputId]="'customDistance'"
              [(ngModel)]="distanceSwitch"
              (onClick)="setDistance()" />
            <label for="customDistance" class="ml-2">{{
              'Only the selected distance' | translate
            }}</label>
            <mat-icon
              class="ml-1 text-blue-500 cursor-pointer text-lg"
              fontIcon="diamond"
              tooltipPosition="right"
              [appendTo]="'body'"
              pTooltip="{{ 'Only for premium subscribers' | translate }}"
              (click)="miscService.openPremium()" />
          </div>
          @if (distanceSwitch) {
            @if (showSearchSettingSetup) {
              <div>
                {{
                  'First, you need to set the address location of the service offers:' | translate
                }}
                <a routerLinkActive="router-link-active" [routerLink]="['/search-settings']">
                  {{ 'Go to search settings' | translate }}</a
                >
              </div>
            } @else {
              <div class="flex flex-wrap m-3">
                <div class="w-full">
                  <h5>{{ 'Distance' | translate }}: {{ distanceFormControl.value }} km</h5>

                  <p-slider
                    [formControl]="distanceFormControl"
                    [id]="'distanceSlider'"
                    [range]="false"
                    [max]="500"
                    [animate]="true" />
                </div>
              </div>
            }
          }
        </div>
      </div>
    }
  </div>
</div>
